import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Autor } from '../model/Autor';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AutorxsService {

  private endpoint = `${environment.apiUrl}/autorxs`;

  constructor(private http: HttpClient) { }

  getAutores(page: number): Observable<{ items: Autor[], total_count: number }> {
    return this.http.get<{ items: Autor[], total_count: number }>(`${this.endpoint}?page=${page}`);
  }

  getAutorById(id: number): Observable<Autor> {
    return this.http.get<Autor>(`${this.endpoint}/${id}`);
  }

}
